import { FC } from 'react'
import useProfile from 'hooks/useProfile'
import PopupContent from 'components/UserInfoPopup/PopupContent'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'

type MentionPopupProps = {
  username: string
}

const normalizeUsername = (value: string) =>
  value.trim().replace(/^@/, '').toLowerCase()

const MentionPopup: FC<MentionPopupProps> = ({ username }) => {
  const [user, isOwnProfile, isLoading] = useProfile({ username })
  const isChannel = user?.channel

  if (!user || isLoading) return null

  if (
    normalizeUsername(getUserNameWithDomain(user)) !==
    normalizeUsername(username)
  ) {
    return null
  }

  return (
    <PopupContent
      user={user}
      isOwnProfile={isOwnProfile}
      isChannel={isChannel}
    />
  )
}

export default MentionPopup
